import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "About", href: "#about" },
    { label: "Research", href: "#research" },
    { label: "Characters", href: "#characters" },
    { label: "Exhibition", href: "#bag-charms" },
  ];

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#F5F3EF] border-b border-[#0D0D0D]/10" : "bg-transparent"
      }`}
    >
      <div className="w-full px-8 md:px-16 flex items-center justify-between h-16">
        {/* Logo */}
        <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo("#hero"); }} className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/79bbd12133c9c5c423ad9964f66c8be6/bf815b424deca47096daf3a9a4c9e38c.png"
            alt="OFF-PATTERN Logo"
            className="h-9 w-auto object-contain"
          />
          <span className={`font-display text-xl tracking-widest transition-colors ${scrolled ? "text-[#0D0D0D]" : "text-white"}`}>
            OFF-PATTERN
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => scrollTo(link.href)}
              className={`font-body text-xs uppercase tracking-[3px] font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? "text-[#2B2B2B] hover:text-[#E63946]" : "text-white/80 hover:text-white"
              }`}
            >
              {link.label}
            </button>
          ))}
          <span className={`font-mono text-[10px] uppercase px-3 py-1.5 rounded-full border whitespace-nowrap ${
            scrolled ? "border-[#E63946] text-[#E63946]" : "border-white/60 text-white/80"
          }`}>
            26 March 2026
          </span>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? "text-[#0D0D0D]" : "text-white"}`}
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#F5F3EF] border-t border-[#0D0D0D]/10 px-8 py-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => scrollTo(link.href)}
              className="font-body text-sm uppercase tracking-[3px] text-[#2B2B2B] hover:text-[#E63946] text-left cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
